export const CUSTOMER_CHANGE_PASSWORD = '/customer/change-password';

export const CUSTOMER_BOOKING_SUMMARY = '/customer/bookings/summary';

export const CUSTOMER_BOOKING_AIRPORT_DETAILS =
  '/customer/bookings/airport-data';
export const CUSTOMER_BOOKING_PASSENGER_DETAILS =
  '/customer/bookings/passenger-data';
export const CUSTOMER_BOOKINGS = '/customer/bookings';
export const CUSTOMER_VIEW_BOOKINGS = '/customer/bookings/view/:bookingId';
export const CUSTOMER_EDIT_BOOKINGS = '/customer/bookings/edit';
export const CUSTOMER_SUCCESS_PAGE = '/customer/bookings/success';
export const CUSTOMER_INVOICES = '/customer/invoices';
export const CUSTOMER_VIEW_INVOICE = '/customer/invoices/view';
export const CUSTOMER_PROFILE_UPDATE = '/customer/profile';
export const CUSTOMER_REPORTS = '/customer/reports';
export const CUSTOMER_BILLING_ADDRESS = '/customer/address';
export const CUSTOMER_ADD_BILLING_ADDRESS = '/customer/address/add';
export const CUSTOMER_EDIT_BILLING_ADDRESS = '/customer/address/edit/:id';
export const CUSTOMER_DASHBOARD = '/customer/dashboard';

export const CUSTOMER_ADD_FAMILY_MEMBER = '/customer/familyMembers/add';
export const CUSTOMER_FAMILY_MEMBERS = '/customer/familyMembers';
export const CUSTOMER_EDIT_FAMILY_MEMBER = '/customer/familyMembers/edit/:id';

export const CUSTOMER_REFERRALS="/customer/referrals"